import { get } from 'lodash';

export const manageBulkIsLoadingSelector = state => get( state, 'domainManagement.manageBulkIsLoading', false );
export const domainManagementErrorsSelector = state => get( state, 'domainManagement.domainErrors', {} );
